import { Component, input } from "@angular/core";
import { FieldTree, FormField } from "@angular/forms/signals";
import { EnergyLabelModel, EnergyLabelsFilterModel } from "./search-filter-energy-labels.model";

@Component({
    selector: "search-filter-energy-labels",
    imports: [FormField],
    templateUrl: "./search-filter-energy-labels.component.html",
    styleUrl: "./search-filter-energy-labels.component.scss",
})
export class SearchFilterEnergyLabelsComponent {
    filterForm = input.required<FieldTree<EnergyLabelsFilterModel>>();

    toggleExpanded(): void {
        this.filterForm().expanded().value.set(!this.filterForm().expanded().value());
    }

    toggleSelectedEnergyLabel(energyLabel: EnergyLabelModel): void {
        const current = this.filterForm().energyLabels().value();
        this.filterForm()
            .energyLabels()
            .value.set(current.map((e) => (e.index === energyLabel.index ? { ...e, selected: !e.selected } : e)));        
    }

    selectAllEnergyLabels(): void {
        if (this.checkIfAllSelected()) {
            this.filterForm().energyLabels().value.update((energyLabels: EnergyLabelModel[]) => {
                return energyLabels.map((energyLabel) => {
                    return {
                        ...energyLabel,
                        selected: false,
                    };
                });
            });
        } else {
            this.filterForm().energyLabels().value.update((energyLabels: EnergyLabelModel[]) => {
                return energyLabels.map((energyLabel) => {
                    return {
                        ...energyLabel,
                        selected: true,
                    };
                });
            });
        }
    }

    private checkIfAllSelected(): boolean {
        return this.filterForm()
            .energyLabels()
            .value()
            .every((energyLabel) => energyLabel.selected);
    }
}
